import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-primary-500 text-sm font-medium tracking-widest uppercase mb-3">
            Blog
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            最新文章
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            了解更多关于医护美学、写真拍摄与时尚穿搭的专业内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-100/80 text-accent-900 text-xs font-medium rounded-md">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.publishedAt}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-md hover:border-primary-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            阅读更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}